import { render } from "./FischbuchEintragLinthkanal.vue?vue&type=template&id=2523dcc8&scoped=true&ts=true"
import script from "./FischbuchEintragLinthkanal.vue?vue&type=script&lang=ts"
export * from "./FischbuchEintragLinthkanal.vue?vue&type=script&lang=ts"

import "./FischbuchEintragLinthkanal.vue?vue&type=style&index=0&id=2523dcc8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2523dcc8"]])

export default __exports__